import {Howl, Howler} from "howler";
import * as PIXI from "pixi.js";
import data from "../configs/data";
import {Button} from "../controlElements/Button";
import {CheckBox} from "../controlElements/CheckBox";
import {HowToPlay} from "../HowToPlay";
import {Info} from "./Info";

export class OptionsPanel extends PIXI.Container {

    private readonly INFO_BUTTON_POSITION = new PIXI.Point(0, 65);
    private readonly VOLUME_CHECKBOX_POSITION = new PIXI.Point(0, 130);

    constructor() {
        super();
        this.createAndAddHowToPlayButton();
        this.createAndAddInfoButton();
        this.createAndAddVolumeCheckbox();
    }

    private createAndAddHowToPlayButton(): void {
        const infoButton = new Button(data.images.howToPlayButtonBase, data.images.howToPlayButtonHover,
            data.images.howToPlayButtonClick, data.images.howToPlayButtonBase, data.audios.buttonClicked);
        this.addChild(infoButton);
        infoButton.subscribeOnClicked(() => {
            HowToPlay.getInstance().toggleVisibility();
        });
    }

    private createAndAddInfoButton(): void {
        const infoButton = new Button(data.images.infoBase, data.images.infoHover, data.images.infoClick,
            data.images.infoClick, data.audios.buttonClicked);
        infoButton.position = this.INFO_BUTTON_POSITION;
        this.addChild(infoButton);
        infoButton.subscribeOnClicked(() => {
            Info.getInstance().toggleVisibility();
        });
    }

    private createAndAddVolumeCheckbox(): void {
        const volumeCheckBox = new CheckBox(data.images.volumeOffBase, data.images.volumeOffHover,
            data.images.volumeOffClick, data.images.volumeOffClick, data.images.volumeOnBase,
            data.images.volumeOnHover, data.images.volumeOnClick,
            data.images.volumeOnClick, data.audios.buttonClicked);
        volumeCheckBox.checked = true;
        volumeCheckBox.position = this.VOLUME_CHECKBOX_POSITION;
        this.addChild(volumeCheckBox);
        volumeCheckBox.subscribeOnClicked((isChecked) => {
            if (isChecked) {
                Howler.volume(1.0);
            } else {
                Howler.volume(0.0);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/OptionsPanel.ts